import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import UserSessionStore from 'shared/flux/stores/UserSessionStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import UserActions from 'shared/flux/actions/UserActions';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';
import {
  ColumnWidthStrings,
  ProofColumnHeaderTitle,
} from 'flux/stores/cuesheet/CuesheetConstants';
import { isMac } from 'shared/lib/platformCheck';

const noteMenuId = 'noteColumnMenu';

export default React.createClass({
  displayName: 'NoteColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(
      UserSessionStore,
      'displayProofOfPerformance',
      (state) => {
        return (
          state.getIn(['preferences', 'displayProofOfPerformance']) !== true
        );
      },
    ),
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    ColumnMenuMixin,
  ],

  render() {
    const showMenu = this.state.popoverVisibility.get(noteMenuId);

    return (
      <PopoverMenu
        className="cs-data-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    const width = this._getCurrentColumnWidth();
    const { userId } = this.state;

    return Map({
      id: noteMenuId,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(noteMenuId),
      onHide: () => PopoverActions.hide(noteMenuId),
      items: OrderedMap({
        hideColumn: Map({
          content: <span>Hide Column</span>,
          onClick: () => this._handleHideColumnClick(),
        }),
        showProofColumn: Map({
          hidden: !this.state.displayProofOfPerformance,
          divider: true,
          content: `Show "${ProofColumnHeaderTitle}" Column`,
          onClick: () =>
            UserActions.updatePreference(
              userId,
              'displayProofOfPerformance',
              true,
            ),
        }),
        setWidthUltraNarrow: Map({
          content: this.getRadioWithLabelNode(
            width === ColumnWidthStrings.UltraNarrow,
            'Set Width Ultra Narrow',
          ),
          onClick: () =>
            this._handleSetColumnWidthClick(ColumnWidthStrings.UltraNarrow),
        }),
        setWidthNarrow: Map({
          content: this.getRadioWithLabelNode(
            width === ColumnWidthStrings.Narrow,
            <span>Set Width Narrow</span>,
          ),
          onClick: () =>
            this._handleSetColumnWidthClick(ColumnWidthStrings.Narrow),
        }),
        setWidthNormal: Map({
          content: this.getRadioWithLabelNode(
            width === ColumnWidthStrings.Normal,
            <span>Set Width Normal</span>,
          ),
          onClick: () =>
            this._handleSetColumnWidthClick(ColumnWidthStrings.Normal),
        }),
        setWidthWide: Map({
          content: this.getRadioWithLabelNode(
            width === ColumnWidthStrings.Wide,
            <span>Set Width Wide</span>,
          ),
          onClick: () =>
            this._handleSetColumnWidthClick(ColumnWidthStrings.Wide),
        }),
        setWidthScriptWide: Map({
          divider: true,
          content: this.getRadioWithLabelNode(
            width === ColumnWidthStrings.ScriptWide,
            <span>Set Width Script Wide</span>,
          ),
          onClick: () =>
            this._handleSetColumnWidthClick(ColumnWidthStrings.ScriptWide),
        }),
      }).filter((item) => item.get('hidden') !== true),
    });
  },

  _getKeyModifier(type) {
    const command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];

    return <span className="shortcut-key-modifier">{command}</span>;
  },

  _getCurrentColumnWidth() {
    return this.props.userSettings.getIn(['noteColumn', 'width']);
  },

  _handleHideColumnClick() {
    CuesheetColumnActions.hideNoteColumn();
  },

  _handleSetColumnWidthClick(width) {
    CuesheetColumnActions.updateNoteColumnWidth(width);
  },
});
